import { useEffect } from 'react';

/**
 * Sets `window.pmc_ready` and dispatches a `pmc_ready` event (hooks for tests)
 * once the app is hydrated and interactive.
 *
 * `hydrateRoot` hydrates asynchronously, and `<Suspense>` boundaries hydrate in
 * a later pass than the shell, so render this inside the boundary that holds the
 * page content: its effect runs only after that boundary's content has hydrated
 * and its event handlers are attached.
 */
export function AppReadySignal() {
  useEffect(() => {
    if (window.pmc_ready === true) {
      return;
    }
    window.pmc_ready = true;
    window.dispatchEvent(new Event('pmc_ready'));
  }, []);

  return null;
}
